module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Pro Gold.2f37aca6.png";